export const APP_PLUGINS = {
  LEAD_CAPTURE_FORM: 'lead-capture-form',
  COUPONS: 'CouponsKeyboard',
  PAYMENT_REQUEST: 'payment-request',
};
